import { atom } from 'jotai';

/** Controls whether the debug chat panel is open. */
export const debugChatOpenAtom = atom(false);
